import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";

const getOptions = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.options;

  return fetch(
    `${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getManagers = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.managers;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getAffiliates = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.affiliates;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getTrackers = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.trackers;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getDeals = () => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.deals;

  const payload = {
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getCreatives = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.creatives;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getProducts = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.products;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getBrands = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.brands;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getCurrencies = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.currencies;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlatforms = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.platforms;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getReport = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.generate_report;

  const sendData = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(sendData))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getColumns = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.columns;

  return fetch(
    `${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setDownload = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.download_report;

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getDeviceTypes = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.full_report.device_types;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getFiltersField = (data: {
	[key: string]: any;
}) => {
	const authenticity_token = getCookie(cookieToken);
	const payload = {
		...data,
		authenticity_token: authenticity_token,
	};

	const mapping = {
		trackerIds: "trackers",
		creativeIds: "creatives",
		brands: "brands",
		currencies: "currencies",
		dealTypes: "deals",
		productIds: "products",
		platformIds: "platforms",
		playerId: "players",
		anid: "anid",
		source1: "source1",
		source2: "source2",
		source3: "source3",
		source4: "source4",
		source5: "source5",
		deviceTypes: "devices",
		managerIds: "managers",
		affiliateIds: "affiliates",
		costOptimizations: "costOptimization",
	};

	//@ts-ignore
	const field = `${mapping[`${data.label}`]}`;

	return fetch(`${api.admin.full_report.filters}/${field}`, {...RequestOptions('POST', JSON.stringify(payload))})
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
}

const getRestoreStatisticsDates = (data: { compositePlayerId: string }) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.full_report.restoreStatisticsDates;

  const payload = {
    ...data,
    authenticity_token,
  };

  return fetch(`${endpoint}`, { ...RequestOptions('POST', JSON.stringify(payload)) })
    .then(handleResponse)
    .then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

const setRestoreStatisticsTask = (data: {
  compositePlayerId: string;
  ftdRestoreDate: string | null;
  filterType: string | null;
  shouldReturnOtherStatistics: boolean;
  otherStatisticsReturnFromDate: string | null;
  otherStatisticsReturnToDate: string | null;
}) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.full_report.restoreStatisticsTask;

  const payload = {
    ...data,
    authenticity_token,
  };

  return fetch(`${endpoint}`, { ...RequestOptions("POST", JSON.stringify(payload)) })
    .then(handleResponse)
    .then((data) => data)
    .catch((error) => error);
};  


export const fullReportService = {
  getOptions,
  getReport,
  getColumns,
  setDownload,
  getManagers,
  getAffiliates,
  getTrackers,
  getDeals,
  getCreatives,
  getProducts,
  getBrands,
  getCurrencies,
  getPlatforms,
  getDeviceTypes,
	getFiltersField,
  getRestoreStatisticsDates,
  setRestoreStatisticsTask,
};
